import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { func, object, string } from 'prop-types';
import Websocket from 'react-websocket';

import { noop } from '@ajaibid/utils';

const { WEBSOCKET_TRADE } = process.env;

const TradeSocket = ({ code, user, onMessage }) => {
  const wsRef = useRef();
  const [isReady, setIsReady] = useState(false);

  const subscribe = useCallback(
    (_code) => {
      if (!isReady) return;
      wsRef.current.sendMessage(
        JSON.stringify({
          id: user.id,
          method: 'SUBSCRIBE',
          stream: 'TRADE',
          streamObject: encodeURI(_code),
          count: 20,
        })
      );
    },
    [isReady]
  );

  const unsubscribe = useCallback(
    (_code) => {
      if (!isReady) return;
      wsRef.current.sendMessage(
        JSON.stringify({
          id: user.id,
          method: 'UNSUBSCRIBE',
          stream: 'TRADE',
          streamObject: encodeURI(_code),
          count: 20,
        })
      );
    },
    [isReady]
  );

  useEffect(() => {
    subscribe(code);

    return () => {
      unsubscribe(code);
    };
  }, [subscribe, unsubscribe, code, isReady]);

  const handleOpen = useCallback(() => {
    setIsReady(true);
    subscribe(code);
  }, [subscribe]);
  const handleMessage = useCallback((data) => onMessage(data), [onMessage]);

  if (user && user.id) {
    return (
      <Websocket
        url={WEBSOCKET_TRADE}
        ref={wsRef}
        onOpen={handleOpen}
        onClose={() => {
          setIsReady(false);
        }}
        reconnect
        debug={process.env.ENVIRONMENT === 'development'}
        onMessage={handleMessage}
      />
    );
  }
  return null;
};

TradeSocket.propTypes = {
  code: string,
  user: object,
  onMessage: func,
};

TradeSocket.defaultProps = {
  code: '*',
  user: null,
  onMessage: noop,
};

export default memo(TradeSocket);
